export const CUSTOM_FONT_PREFIX = '--font';

export const isCustomFont = (v) => (v ? v.startsWith(CUSTOM_FONT_PREFIX) : false);

export const getCustomFont = (f) => (f ? f.split(CUSTOM_FONT_PREFIX)[1] : null);

export const CUSTOM_FONT_VAR_PREFIX = '--fontVar';

// CSS <custom-ident> values must not start with '--' (reserved for CSS custom properties).
// Transform '--fontXxx' → 'customFont-Xxx' for use in font-family styles and FontFace registration.
export const toSafeFontName = (name) => (name && isCustomFont(name) ? `customFont-${name.slice(CUSTOM_FONT_PREFIX.length)}` : name);
